<template>
  <div class="success-box" v-show="successShow">
    <div class="success-mask"></div>
    <div class="success-content">
      <i class="iconfont icon-close icon" @click="handleCloseSuccess"></i>
      <div class="content">
        <img src="./../../../assets/image/success.png" alt="" />
        <h3>提交申请成功</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'success-box',
  props: {
    successShow: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    handleCloseSuccess() {
      this.$emit('CloseSuccess')
    }
  }
}
</script>

<style lang="scss" scoped>
.success-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  .success-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
    z-index: 100;
  }
  .success-content {
    position: absolute;
    left: 10%;
    top: 50%;
    margin-top: -50%;
    width: 80%;
    height: 280px;
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;
    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }
    .content {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 56px;
        height: 56px;
      }
      h3 {
        margin-top: 28px;
        color: #222222;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
}
</style>
